export const maintenanceMode = () => {
  return false
}
